import Vue from "vue";
import {
  installVue2Logger,
  instrumentAxios,
  instrumentVueRouter,
} from "@apps-logs/vue2";
import router from "@/router";
import axios from "@/plugins/axios";
import logger from "@/plugins/appsLogsCore";

installVue2Logger(Vue, { logger });

if (router) {
  instrumentVueRouter(router, { logger });
}

if (axios) {
  instrumentAxios(axios, {
    logger,
    slowRequestMs: 3000,
    ignoredUrls: [/\/app$/, "/health"],
  });
}

Vue.prototype.$logger = logger;

export default logger;
